



























/**
 * @copyright       Palace Resorts
 * @description     Pantalla modal edit
 */
import i18nMessages from "./i18n/messages";
import GlobalMixin from "@/mixins/global";
import dataService from "@/services/proveedoresAPI";
import ResponseData from "@/models/store/ProveedoresTypesData";
export default GlobalMixin.extend({
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma
  i18n: i18nMessages,
  props: {
    dialogDelete: { type: Boolean, default: false },
    registroSTPSEdit: { type: Object, default: {} },
  },
  data: () => {
    return {
      // GENERAL
      moduleName: "DIALOG_DELETE",
    };
  },

  methods: {
    closeDelete() {
      this.$emit("closeDelete");
    },
    deleteItemConfirm() {
      dataService
        .deleteRegisterSTPS(this.registroSTPSEdit.registroSTPSID)
        .then((Response: ResponseData) => {
          if (Response.data.data[0]) {
            this.registroSTPSEdit.registroSTPSID = Response.data.data[0].id;
            this.$emit(
              "notificacion",
              "Registro eliminado correctamente",
              "success"
            );
            this.$emit("deleteItemConfirm");
          } else {
            this.$emit(
              "notificacion",
              "No se pudo eliminar el registro, intente de nuevo más tarde",
              "red darken-2"
            );
          }
        })
        .catch((e: Error) => {
          this.$emit(
            "notificacion",
            "No se pudo eliminar el registro, intente de nuevo más tarde" + e,
            "red darken-2"
          );
        });
    },
  },
});
